import React, {Component} from "react"

class Report extends Component {


  render() {
    const width = this.props.width || 190
    return (
      <div className="white-bg wrapper wrapper-content p-xl" style={{width: `${width}mm`}}>
        <div className="clear">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Report



// WEBPACK FOOTER //
// ./src/components/report/Report.js